import Button, { ButtonVariants } from '@features/ui-form/components/Button';
import Box from '@mui/joy/Box';

type NewMessageToastProps = {
  preview: string;
  viewLabel: string;
  onView: () => void;
};

/** Body of the toast raised when a message arrives: what was written, and a way in. */
export const NewMessageToast = ({ preview, viewLabel, onView }: NewMessageToastProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, minWidth: 0, width: '100%' }}>
    <Box
      sx={{
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        // Without an explicit width the line box grows to fit the whole message and
        // the clamp just clips it off the toast's edge instead of wrapping.
        width: '100%',
        minWidth: 0,
        overflowWrap: 'anywhere',
      }}
    >
      {preview}
    </Box>
    <Button variant={ButtonVariants.TEXT} label={viewLabel} onClick={onView} data-testid="new-message-toast-view" />
  </Box>
);
